import {BlockEmbed} from './block';
import Aside from './aside';
import AsideContainer from './asideContainer';
import autocomplete from 'autocompleter';

class AsideArticles extends BlockEmbed {
  static create(value) {
    console.log('asideArticles create');
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode, selected) {
    console.log('asideArticles constructor');
    
    super(scroll, domNode);
    this.articles = [];
    this.selected = [];
    this.editMode = false;
    
    if (selected) {
      const selectedAttr = selected.join(',');
      this.selected = selected;
      this.domNode.dataset.selected = selectedAttr;
      this.fetch(selectedAttr);
    }
    
    // статьи
    const container = document.createElement('div');
    container.className = 'container-list';
    this.domNode.appendChild(container);
    
    this.grid = document.createElement('ul');
    // this.grid.className = 'list';
    container.appendChild(this.grid);
    
    // контейнер для режима редактирования
    const editContainer = document.createElement('div');
    editContainer.className = 'container-edit';
    this.domNode.appendChild(editContainer);
    
    const editButtons = document.createElement('div');
    editButtons.className = 'buttons';
    editButtons.innerText = 'Управление блоком';
    editContainer.appendChild(editButtons);
  
    this.btnSave = document.createElement('button');
    this.btnSave.setAttribute('type', 'button');
    this.btnSave.innerText = 'Сохранить';
    this.btnSave.addEventListener('click', this.changeMode.bind(this));
    editButtons.appendChild(this.btnSave);
    
    this.btnDestroy = document.createElement('button');
    this.btnDestroy.setAttribute('type', 'button');
    this.btnDestroy.innerText = 'Удалить';
    this.btnDestroy.addEventListener('click', this.remove.bind(this));
    editButtons.appendChild(this.btnDestroy);
    
    this.editGrid = document.createElement('div');
    editContainer.appendChild(this.editGrid);
    
    const onRemove = this.removeSelectedArticle.bind(this);
    
    editContainer.addEventListener('click', function(e) {
      if (e.target && e.target.classList.contains('ql-article-card-remove')) {
        const slug = e.target.dataset.slug;
        onRemove(slug);
      }
    });
    
    // кнопка переключения между режимами
    const btnMode = document.createElement('button');
    btnMode.setAttribute('type', 'button');
    btnMode.className = 'btn-mode';
    btnMode.innerText = 'Редактировать';
    btnMode.addEventListener('click', this.changeMode.bind(this));
    this.domNode.appendChild(btnMode);
  }
  
  fetch(selected) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', API_DOMAIN + '/api/v0/article/selected?selected='+selected, true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.articles = JSON.parse(xhr.responseText);
        // this.editMode = this.articles.length === 0;
        this.updateEditable();
      }
    };
    xhr.send(null);
  }
  
  changeMode() {
    this.editMode = !this.editMode;
    this.updateEditable();
  }
  
  updateGrid() {
    this.grid.innerHTML = '';
    this.articles.map(article => {
      this.grid.appendChild(AsideArticles.createMarkup(article));
    });
  }
  
  updateEditGrid() {
    this.editGrid.innerHTML = '';
    
    const searchField = document.createElement('input');
    searchField.classList.add('ql-article-search');
    searchField.setAttribute('placeholder', 'Поиск статей по названию');
    searchField.autofocus = true;
    
    const onSelect = this.addSelectedArticle.bind(this);
  
    autocomplete({
      input: searchField,
      debounceWaitMs: 300,
      minLength: 3,
      fetch: function (text, callback) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', API_DOMAIN + '/api/v0/article/search?keyword='+searchField.value, true);
        xhr.onload = () => {
          if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            callback(data);
          }
        };
        xhr.send(null);
      },
      render: function(article) {
        const div = document.createElement('div');
        div.textContent = article.title;
        return div;
      },
      onSelect: onSelect
    });
    
    
    const previewList = document.createElement('ul');
    previewList.classList.add('list');
    
    this.editGrid.appendChild(searchField);
    this.editGrid.appendChild(previewList);

    this.articles.map(article => {
      previewList.appendChild(AsideArticles.createEditMarkup(article));
    });
    
    if (this.articles.length) {
      this.btnSave.style.display = 'block';
      this.btnDestroy.style.display = 'none';
    } else {
      this.btnSave.style.display = 'none';
      this.btnDestroy.style.display = 'block';
    }
  }
  
  refreshGrid() {
    this.domNode.dataset.selected = this.selected.join(',');
    if (this.editMode) {
      this.updateEditGrid();
    } else {
      this.updateGrid();
    }
  }
  
  updateEditable() {
    this.domNode.classList.toggle('edit', this.editMode);
    this.refreshGrid();
  }
  
  static value(domNode) {
    return domNode.dataset.selected.split(',');
  }
  
  static createMarkup(article) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="article-card">
      <img class="article-card-image" src="${article.image}">
      ${article.title}
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  static createEditMarkup(article) {
    const element = document.createElement('li');
    element.innerHTML = `<div class="ql-article-card">
      <figure class="ql-article-card-media">
        <img class="ql-article-card-image" src="${article.image}">
      </figure>
      <div class="h6 ql-article-card-title">${article.title}</div>
      <span class="ql-article-card-remove" title="убрать" data-slug="${article.slug}">х</span>
    </div>`.replace(/(\r\n\s+|\n\s+|\r\s+)/gm, '');
    
    return element;
  }
  
  addSelectedArticle(article) {
    if (this.selected.indexOf(article.slug) === -1) {
      const oldSelected = this.selected.join(',');
      this.articles.push(article);
      this.selected.push(article.slug);
      
      this.updateCache(oldSelected, this.selected.join(','));
    }
    this.refreshGrid();
  }
  
  removeSelectedArticle(slug) {
    const oldSelected = this.selected.join(',');
    this.articles = this.articles.filter(article => article.slug !== slug );
    this.selected.splice(this.selected.indexOf(slug), 1);
    this.updateCache(oldSelected, this.selected.join(','));
    this.refreshGrid();
  }
  
  updateCache(oldKey, newKey) {
    if (oldKey === newKey) {
      return;
    }
    
    oldKey && AsideContainer._articleCache.remove(oldKey);
    newKey && AsideContainer._articleCache.set(newKey, this);
  }
}

AsideArticles.tagName = 'DIV';
AsideArticles.blotName = 'asideArticles';
AsideArticles.className = 'aside-articles';
AsideArticles.requiredContainer = Aside;

export default AsideArticles;